/**
 * Array.isArray polyfill
 */
if (!Array.isArray) {
    Array.isArray = function (arg) {
        return '[object Array]' === Object.prototype.toString.call(arg);
    };
}

/**
 * Number.isInteger polyfill
 */
Number.isInteger = Number.isInteger || function (value) {
    return 'number' === typeof value && isFinite(value) && Math.floor(value) === value;
};

import 'core-js/stable';
import 'regenerator-runtime/runtime';

